__turbopack_context__.v({
  "Empty": "index-module__AXgR2G__Empty",
  "Input": "index-module__AXgR2G__Input",
  "Item": "index-module__AXgR2G__Item",
  "ItemIndicator": "index-module__AXgR2G__ItemIndicator",
  "ItemText": "index-module__AXgR2G__ItemText",
  "Label": "index-module__AXgR2G__Label",
  "List": "index-module__AXgR2G__List",
  "Popup": "index-module__AXgR2G__Popup",
  "Positioner": "index-module__AXgR2G__Positioner",
  "Scroller": "index-module__AXgR2G__Scroller",
  "VirtualizedPlaceholder": "index-module__AXgR2G__VirtualizedPlaceholder",
});
